// extracted by mini-css-extract-plugin
module.exports = {"mobile":"styles_mobile__3_OQA","desktop":"styles_desktop__TN-LN"};